import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../../auth/authentication-service';
import { BaseApiService } from '../baseApiService';
import { RecommendedService } from './recommendedService';
import { RecommendedServiceUp } from './recommendedServiceUp';

@Injectable({
  providedIn: 'root'
})
export class RecommendedServiceApiService extends BaseApiService {
  constructor(http: HttpClient, authService: AuthenticationService) {
    super(http, authService);
  }

  getRecommendedServicesForAsset(assetId: string): Observable<RecommendedService[]> {
    if (!assetId.trim()) {
      return of();
    }

    return this.http.get<RecommendedService[]>(`${this.apiUrl}/api/v5/assets/${assetId}/recommended-services`).pipe(
      catchError(this.handleError<RecommendedService[]>('getRecommendedServicesForAsset', undefined))
    );
  }

  getRecommendedService(recommendedServiceId: string): Observable<RecommendedServiceUp> {
    if (!recommendedServiceId.trim()) {
      return of();
    }

    return this.http.get<RecommendedServiceUp>(`${this.apiUrl}/api/v5/recommended-services/${recommendedServiceId}`).pipe(
      catchError(this.handleError<RecommendedServiceUp>('getRecommendedService', undefined))
    );
  }
}
